/*
 * Lens guard (Tier A) — keeps every theme-side checkout entry point in sync
 * with the server-computed "a light requires a lens" verdict.
 *
 * The verdict itself is computed in Liquid (snippets/lens-guard.liquid) and
 * surfaced as data-lens-invalid="true|false" on #main-cart-footer. Dawn only
 * re-renders the footer's totals (.js-contents) on a cart change, so the
 * checkout button and express buttons keep stale state — this script reads the
 * fresh verdict and applies it to the live DOM whenever the cart updates.
 *
 * This is a client-side guardrail, not unbypassable enforcement.
 */
(function () {
  if (window.__lensGuardInit) return;
  window.__lensGuardInit = true;

  var FOOTER_SECTION_ID = 'main-cart-footer';

  function parseVerdict(htmlString) {
    var doc = new DOMParser().parseFromString(htmlString, 'text/html');
    var el = doc.querySelector('[data-lens-invalid]');
    return el ? el.getAttribute('data-lens-invalid') === 'true' : false;
  }

  function applyVerdict(invalid) {
    // Cart page — standard checkout button.
    var checkout = document.getElementById('checkout');
    if (checkout) checkout.toggleAttribute('disabled', invalid);

    // Cart page — dynamic/express checkout buttons (Shop Pay, PayPal, etc.).
    var express = document.querySelector('.cart__dynamic-checkout-buttons');
    if (express) express.style.display = invalid ? 'none' : '';

    // Cart notification popup — checkout button.
    var notifBtn = document.querySelector('#cart-notification-form button[name="checkout"]');
    if (notifBtn) notifBtn.toggleAttribute('disabled', invalid);

    // Warning messages on any surface.
    var warnings = document.querySelectorAll('[data-lens-warning]');
    for (var i = 0; i < warnings.length; i++) {
      warnings[i].toggleAttribute('hidden', !invalid);
    }
  }

  function refresh(event) {
    var footer = document.getElementById('main-cart-footer');
    var sectionId = footer ? footer.dataset.id : FOOTER_SECTION_ID;
    var sections = event && event.cartData && event.cartData.sections;

    // On the cart page the freshly rendered footer is already in the event
    // payload — use it without an extra request.
    if (sections && sections[sectionId]) {
      applyVerdict(parseVerdict(sections[sectionId]));
      return;
    }

    // Otherwise (e.g. add-to-cart from a product page) fetch just the footer
    // section to recompute the verdict against the full cart.
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(cartUrl + '?section_id=' + sectionId)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        applyVerdict(parseVerdict(text));
      })
      .catch(function () {
        /* leave the server-rendered state in place on failure */
      });
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
